module.exports = __webpack_public_path__ + "static/media/view2.b6d5cc24.jpg";